export enum ButtonType {
  SURE = '確定',
  BACK_TO_MODIFY = '返回修改',
  AGREE = '同意',
  DISAGREE = '不同意',
  CORRECT = '資料無誤',
}
